import "./App.css";
import { Homepage } from "./Pages/Homepage";
import { BrowserRouter, Route, Routes, Navigate, useParams } from "react-router-dom";
import { Preview } from "./Pages/Preview";

/** Remount when appointment/patient changes so form state does not leak across URLs */
function HomepageRoute() {
  const { id, patientId } = useParams();
  return <Homepage key={`${id}-${patientId}`} />;
}

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Root redirect - only affects localhost, production uses direct appointment links */}
          <Route path="/" element={<Navigate to="/test123/test456" replace />} />
          {/* Main form route - works with real appointment IDs in production */}
          <Route path="/:id/:patientId" element={<HomepageRoute />} />
          {/* Preview route */}
          <Route path="/preview" element={<Preview />} />
        </Routes>
        
      </BrowserRouter>
    </>
  );
}

export default App;
